import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'shippingPdfPrices',
  initialState: { hiddenByUser: {} },
  reducers: {
    toggleShippingPdfPrices(state, action) {
      const user = String(action.payload);
      state.hiddenByUser[user] = !state.hiddenByUser[user];
    },
  },
});
export const { toggleShippingPdfPrices } = slice.actions;
export default slice.reducer;
